export default __webpack_public_path__ + "static/media/visualizer.4071bf3a.png";